/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.0
 */

import './wdyr';
import 'core-js';
import 'abortcontroller-polyfill';
import { TailoredProvider, useTheme } from '@nexign/scc-ui-kit';
import { ConnectedRouter } from 'connected-react-router';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import appPolyfill from './app-polyfill';
import { globalAppStore } from './globalAppStore';
import appHistory from './modules/app/appHistory';
import SafeApp from './modules/app/components/SafeApp';
import { fonts, palette as kitColors } from './theme';

declare global {
    // eslint-disable-next-line
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any;
        dataLayer: any;
        medalliaAccessLevelId?: number;
        medalliaInnerSegmentId?: number;
        routesConfig: any;
        theme: any;
        hermes: any;
    }
}

const MOUNT_NODE = document.getElementById('root');
appPolyfill();

const RootComponent = () => {
    const theme = useTheme();
    theme.mode = 'standard';
    return (
        <Provider store={globalAppStore}>
            <ConnectedRouter history={appHistory}>
                <ThemeProvider theme={theme}>
                    <SafeApp />
                </ThemeProvider>
            </ConnectedRouter>
        </Provider>
    );
};

render(
    <TailoredProvider colors={kitColors} fonts={fonts.fontFamilies}>
        <RootComponent />
    </TailoredProvider>,
    MOUNT_NODE,
);
